import { render } from "./AdminDetailsComponent.vue?vue&type=template&id=718c6e6b&scoped=true"
import script from "./AdminDetailsComponent.vue?vue&type=script&lang=js"
export * from "./AdminDetailsComponent.vue?vue&type=script&lang=js"

import "./AdminDetailsComponent.vue?vue&type=style&index=0&id=718c6e6b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718c6e6b"]])

export default __exports__